import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import BidPackageCreateUpdateComponent from '../../components/bid-packages/BidPackageCreateUpdateComponent';
import { BidPackage, createBidPackageAsync } from '../../modules/bid-packages';
import {
  getBidPackageFileAPIPath,
  initializeUploadProps,
} from '../../util/utils';
import qs from 'qs';
interface BidPackageCreateContainerProps {
  enterpriseId: string;
  projectId: string;
}
function BidPackageCreateContainer({
  match,
  history,
}: RouteComponentProps<BidPackageCreateContainerProps>) {
  const { enterpriseId, projectId } = match.params;
  const { isBudgeting } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });
  // const [gongjongs, setGongjongs] = useState<Tag[]>();
  // const [materialVendorTypes, setMaterialVendorTypes] = useState<Tag[]>();
  const dispatch = useDispatch();
  const [uploadProps, setUploadProps] = useState<any>();

  useEffect(() => {
    (async () => {
      setUploadProps(
        await initializeUploadProps(
          getBidPackageFileAPIPath(enterpriseId, projectId),
        ),
      );
    })();
    // (async () => {
    //   setGongjongs(await getEnterpriseTags('gongjong'));
    // })();
    // (async () => {
    //   setMaterialVendorTypes(await getEnterpriseTags('materialVendorType'));
    // })();
  }, [enterpriseId, projectId]);
  const onFinish = (bidPackage: BidPackage) => {
    const bidPackageObj = {
      ...bidPackage,
      startDate:
        bidPackage.startDate === ''
          ? ''
          : moment(bidPackage.startDate).format('YYYY-MM-DD'),
      endDate:
        bidPackage.endDate === ''
          ? ''
          : moment(bidPackage.endDate).format('YYYY-MM-DD'),
      bidDueDateTime:
        bidPackage.bidDueDateTime === ''
          ? ''
          : moment(bidPackage.bidDueDateTime).format('YYYY-MM-DD HH:mm'),
      jobWalkDateTime:
        bidPackage.jobWalkDateTime === ''
          ? ''
          : moment(bidPackage.jobWalkDateTime).format('YYYY-MM-DD HH:mm'),
      enterpriseId,
      projectId,
      isBudgeting: isBudgeting === 'true' ? true : false,
    };
    if (bidPackageObj.attachedFiles) {
      for (const _file of bidPackageObj.attachedFiles) {
        if ('response' in _file) {
          _file.path = _file.response.path;
          _file.mimeType = _file.response.mimeType;
        }
      }
    }

    dispatch(
      createBidPackageAsync.request({
        enterpriseId,
        projectId,
        bidPackage: bidPackageObj,
      }),
    );
    // history.goBack();
  };
  const onCancel = () => {
    history.goBack();
  };

  return (
    <>
      {uploadProps && (
        <BidPackageCreateUpdateComponent
          onFinish={onFinish}
          onCancel={onCancel}
          enterpriseId={enterpriseId}
          projectId={projectId}
          uploadProps={uploadProps}
        />
      )}
    </>
  );
}

export default BidPackageCreateContainer;
